export default "__VITE_ASSET__Cwds3xhT__"